<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div
        class="form-box card-base card-shadow--medium white-text"
        :class="{ 'form-box-app': mfaMode === 'app' }"
      >
        <img
          class="image-logo"
          :src="logoURL"
          alt="logo"
          style="margin-bottom: 0"
        />

        <p
          v-if="mfaMode !== 'app'"
          class="text-left mb-20"
          style="font-size: 13.5px"
        >
          We just sent you a message via
          {{ mfaMode === "sms" ? "SMS" : "email" }} with your authentication
          code. Enter the code in the form below to verify your identity.
        </p>
        <div style="font-size: 14px" v-else>
          <h3 class="mb-0">Scan the QR Code</h3>
          <p class="mt-5">
            Use an authenticator app or browser extension to scan.
          </p>
          <img :src="qrcodeUrl" width="180" height="180" alt="QRCode Url" />
          <p class="mb-5">
            Unable to scan? Use the secret key to manually configure your
            authenticator app.
          </p>
          <p style="color: white; margin-top: 0">
            Secret Key:
            <span style="font-weight: 600">{{ secret }}</span>
          </p>
          <h3 class="mb-0">Verify the code from the app</h3>
        </div>

        <form class="mt-0" @submit.prevent="submit">
          <el-input
            v-model="otp"
            ref="code"
            placeholder="XXXXXX"
            maxlength="6"
            v-mask="'######'"
            v-loading="processing"
          >
            <template slot="prefix">Code</template>
          </el-input>
          <div class="flex text-center center pt-10 pb-10">
            <el-button
              type="primary"
              class="login-btn"
              @click="cancel"
            >
              Cancel
            </el-button>
          </div>
        </form>

        <div v-if="mfaMode !== 'app'">
          <hr />
          <p style="font-size: 14px">
            Didn't get a code?
            <el-button
              native-type="button"
              type="text"
              size="small"
              style="padding: 0"
              v-loading="resendProcessing"
              :disabled="resendProcessing"
              @click="resendOTP"
            >
              Resend code
            </el-button>
          </p>
        </div>
      </div>
    </div>
  </vue-scroll>
</template>

<script>
import { apiV2Host } from "@/feathers/feathers-client";

export default {
  name: "VerifyMFA",

  data() {
    return {
      otp: "",
      processing: false,
      resendProcessing: false,
    };
  },

  watch: {
    otp() {
      if (this.otp.length === 6) {
        this.submit();
      }
    }
  },

  computed: {
    logoURL() {
      return this.$store.state.branding.logoOnlyURL;
    },

    mfaMode() {
      return this.$route.query.mode;
    },

    formValid() {
      return this.otp && this.otp.length === 6;
    },

    qrcodeUrl() {
      return this.$store.state.qrcodeUrl;
    },

    secret() {
      return this.$route.query.secret;
    },
  },

  methods: {
    notifyErrorOnApiCall(json = {}) {
      const { name, code, message } = json;
      if (code && ["4", "5"].includes(`${code}`[0])) {
        this.$notify({
          title: name,
          message: message,
          type: "error",
        });
        this.otp = "";
      }
    },

    async submit() {
      try {
        this.processing = true;

        const { query } = this.$route;

        const body = {
          token: query.token,
          otp: this.otp,
          mode: this.mfaMode,
        };

        if (body.mode === "sms") {
          body.phoneNumber = query.phoneNumber;
        }

        if (body.mode === "app") {
          body.secret = query.secret;
        }

        const res = await fetch(`${apiV2Host}/mfa/verify`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await res.json();

        const { accessToken } = json;

        if (accessToken) {
          await this.$store.dispatch("auth/authenticate", {
            strategy: "jwt",
            accessToken: accessToken,
          });
          this.$store.commit("setLogin");
          this.$router.push("/omnia/contacts");
        }

        this.notifyErrorOnApiCall(json);
        this.processing = false;
      } catch (err) {
        this.processing = false;
        this.$notify({
          title: err.name,
          message: err.message,
          type: "error",
        });
      }
    },

    async resendOTP() {
      try {
        this.resendProcessing = true;

        const { query } = this.$route;

        const body = {
          token: query.token,
          mode: this.mfaMode,
        };

        if (body.mode === "sms") {
          body.phoneNumber = query.phoneNumber;
        }

        const res = await fetch(`${apiV2Host}/mfa/resend-otp`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
          },
        });

        const json = await res.json();
        this.resendProcessing = false;

        const { mfaVerifyToken, mode } = json;

        if (mfaVerifyToken) {
          const deviceType = mode === "sms" ? "phone number" : "email";

          this.$notify({
            title: "Check your inbox",
            message: `A 6-digit code has been resent to your ${deviceType}.`,
            type: "success",
          });

          this.$router.push({
            path: "verify-mfa",
            query: { ...query, token: mfaVerifyToken },
          });
        }

        this.notifyErrorOnApiCall(json);
      } catch (err) {
        this.resendProcessing = false;
        this.$notify({
          title: err.name,
          message: err.message,
          type: "error",
        });
      }
    },

    cancel() {
      this.$router.replace("login");
    },
  },
  mounted() {
   this.$refs.code.focus()
  }
};
</script>

<style lang="scss" scoped>
.form-box.card-base.form-box-app {
  max-width: 400px;
}

.card-base form {
  margin-top: 0;
  padding-top: 0;
}
</style>
